import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Flex, Box, Copy, Image } from '@elparking/components'

function CancelationInfo (props) {
    return (
        <Flex>
            <Box flex='0 1 auto' mr='0.5em'>
                <Image src='/images/24h-watch.svg' width='20px' alt='24h' />
            </Box>
            <Box>
                <Copy padding='0' color='gray60' size='xSmall' fontWeight='medium'>
                    <FormattedMessage
                      defaultMessage='Cancelación gratuita hasta 24h antes de que empiece tu reserva'
                    />
                </Copy>
            </Box>
        </Flex>
    )
}

export default CancelationInfo
